import { isHTMLElementNode } from '../helpers/serializerHelpers';
import Serializer, {
  type DeserializeArguments,
  type SerializeArguments,
} from './Serializer';
import { type Descendant } from 'slate';

class SerializerAllowedMedia extends Serializer {
  static serialize(params: SerializeArguments) {
    return null;
  }

  static deserialize({
    el,
    next,
    markAttributes,
    options,
  }: DeserializeArguments): Descendant[] | undefined {
    if (!isHTMLElementNode(el)) return;
    if (!options.allowedMediaRegex) return;
    if (!['img', 'video', 'audio'].includes(el.tagName.toLowerCase())) return;
    if (options.allowedMediaRegex.exec(el.getAttribute('src') ?? '')) return;

    return next(el.childNodes, markAttributes);
  }
}

export default SerializerAllowedMedia;
